/**
 * Secure random utility functions for SAST compliance
 * 
 * Note: These functions use crypto.getRandomValues() to satisfy SAST requirements,
 * but they are designed for non-security-critical purposes (UI animations, effects).
 * 
 * For security-critical operations (tokens, keys, passwords), use dedicated
 * cryptographic libraries and ensure proper entropy sources.
 */

/**
 * Generate a secure random number between 0 and 1 (equivalent to Math.random())
 * Uses crypto.getRandomValues() for SAST compliance
 */
export function secureRandom(): number {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return array[0] / (0xffffffff + 1);
}

/**
 * Generate a secure random integer between min (inclusive) and max (exclusive)
 */
export function secureRandomInt(min: number, max: number): number {
  return Math.floor(secureRandom() * (max - min)) + min;
}

/**
 * Generate a secure random number between min and max
 */
export function secureRandomRange(min: number, max: number): number {
  return secureRandom() * (max - min) + min;
}
